import {
  leagueRoute,
  resolveWatchLeague,
  watchAddresses,
} from "@softmax/web-features/leagues";

import { watchSeed } from "../watch-seed.data";

export async function readWatchEntry({
  signal,
  selection,
}: {
  signal?: AbortSignal | undefined;
  selection: {
    leagueId: string | null;
    stored: string | null;
    globalKiosk: boolean;
  };
}) {
  const seed = await watchSeed({
    signal,
    address: selection,
    withState: false,
    withNavigation: selection.globalKiosk,
  });
  const leagues = seed.leagues ?? [];
  const league = resolveWatchLeague({
    leagues,
    addresses: watchAddresses(leagues),
    address: selection,
  });

  if (!selection.globalKiosk && league)
    return {
      kind: "canonical" as const,
      route: leagueRoute(league),
      leagueId: league.id,
      viewer: seed.viewer,
    };

  return { kind: "theater" as const, seed };
}
